import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { mobile } from '~/techstyle-shared/react-components';

import AccountBox from '../AccountBox';

const Wrapper = styled(AccountBox)`
  ${AccountBox.Content} {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 32px;
    line-height: 18px;
    margin: ${({ theme }) => theme.sizes.lg}px auto;
  }

  ${mobile`
    margin-top: 160px;
  `}
`;

const AccountInfoEmptyLayout = ({ children }) => <Wrapper>{children}</Wrapper>;

AccountInfoEmptyLayout.propTypes = {
  children: PropTypes.node,
};

export default AccountInfoEmptyLayout;
